/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class UserForm {
    id="";
    firstName = "";
    lastName = "";
    username = "";
    caseNotification = true;
    leadNotification = true;
    timeZoneId = "";
    active = true;
    roleId = {
        id:"",
        code:"",
        description:"" ,
        privileges:[]
    };
    dealers = [];
    timezone={
       id:"",
        zone:"",
        description:"" , 
    };
    constructor(
        id:string,
        firstName: string,
        lastName: string,
        username: string,
        emailNotification: boolean,
        timeZone: string,
        status: boolean,
        userLevel: any,
        dealers: any,
        timezone:any,
    ) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.username = username;
        this.leadNotification = emailNotification;
        this.caseNotification = emailNotification;
        this.timeZoneId = timeZone;
        this.active = status;
        this.roleId = userLevel;
        this.dealers = dealers;
        this.timezone=timezone;

    }
}


export class UserSearchForm {
    firstName = "";
    lastName:any = "";
    email = "";
    active: any;
    dealerId = "";
    userId = 0;
    offset = 0;
    pageLimit = 10;
    isPagination:boolean = true
    countryIds:any =[]
    constructor(
        firstName: string,
        lastName: string,
        email: string,
        active: boolean,
        dealerId: any,
        userId: number,
        offset: number,
        pageLimit: number,
        isPagination:boolean,
        countryIds:any
    ) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.active = active;
        this.dealerId = dealerId;
        this.userId = userId;
        this.offset = offset;
        this.pageLimit = pageLimit;
        this.isPagination = isPagination;
        this.countryIds = countryIds
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/models/data-model.ts